import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Tool } from '../../types/tools';
import { GET_STARTED_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
import { ToolIcon } from './ToolIcon';
export function ToolFinalCta({
  tool
}: {
  tool: Tool;
}) {
  return <section aria-labelledby="tool-cta-heading" className="relative overflow-hidden border-b border-hairline-soft bg-ink" data-id="element-358" data-mp="1cyhmwwt5nxcp">
      <div className="sf-dot-texture pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-359" data-mp="2amro59l4ah2r" />
      <Reveal className="relative mx-auto flex w-full max-w-[880px] flex-col items-center px-4 py-20 text-center sm:px-6 lg:py-28" data-id="element-360" data-mp="25nyczntaz25r">
        <ToolIcon name={tool.icon} size="lg" data-id="element-361" data-mp="1vwc0zp954z1y" />
        <h2 id="tool-cta-heading" className="sf-display mt-6 text-balance text-[32px] leading-[1.06] text-text-primary sm:text-[46px]" data-id="element-362" data-mp="1vvivssptyhlx">
          {tool.finalCta.heading}
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-text-secondary" data-id="element-363" data-mp="2oiwuowd39n8o">{tool.finalCta.body}</p>
        <CtaButton href={GET_STARTED_URL} event="tool_cta_click" eventParams={{
        tool: tool.slug,
        placement: 'final'
      }} size="xl" className="mt-8 w-full sm:w-auto" data-id="element-364" data-mp="3afguhxz44n0">
          Try {tool.name}
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-365" data-mp="3uobgww232kuh" />
        </CtaButton>
      </Reveal>
    </section>;
}